const $ = jQuery.noConflict();
import Global from '../shared/global';

'use strict';
const Menu = {
    /**
     * @description Cache dom and strings
     * @type {object}
     */
    $domMenuBtn: $('.js-menu-btn'),
    $domMenuBtnClose: $('.js-mm-menu-close'),
    $domMenuBtnIcon: $('.mm-holder-icon'),
    $domMenuNav: $('.js-main-nav'),
    $domMenuNavWrapper: $('.js-primary-menu-wrapper'),
    $domMenuHasSub: $('.menu-item-has-children'),
    $domHeader: $('.site-header'),
    $domPreheaderRightListItemSubMenu: $('.site__preheader-right-list .site__preheader-right-list-item-submenu'),
    $domPreheaderRightListItem: $('.primary-menu .site__preheader-right-list-item'),
    $domSalesmanDropdown: $('.js-dropdown'),
    $domDropdownItem: $('.js-dropdown-click'),
    $searchInput: $('.js-search-suggestions-input'),
    classOpen: 'open',
    classOpenMenu: 'menu-open',
    classHeaderScroll: 'site-header--scroll',
    classSitePreheaderSubActive: 'site__preheader-right-list-item-submenu--active',
    classSitePreheaderSubDeActive: 'site__preheader-right-list-item-submenu--deactive',

    /** @description Initialize */
    init: function() {
        if ($('.js-dropdown').length && window.innerWidth < 820) {
            $('.site__preheader-wrapper').append($('.js-dropdown'));
        }

        if (window.innerWidth > 820) {
            this.toggleMegaMenuItems();
        }

        if (window.innerWidth < 820) {
            this.appendMegaMenu();
            this.showHideSubMenu();
            this.mergeTopMenu();
            this.showHideDropdown();
        }

        if (window.innerWidth < 820) {
            $('.menu-item-has-children').each(function(i, el) {
                $(el).append('<span class="sub-icon" data-open-sub><span class="hamburger-menu__icon svg-icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 768 768" fill="currentColor"><path d="M169.376 310.624l192 192c12.512 12.512 32.768 12.512 45.248 0l192-192c12.512-12.512 12.512-32.768 0-45.248s-32.768-12.512-45.248 0L384 434.752 214.624 265.376c-12.512-12.512-32.768-12.512-45.248 0s-12.512 32.768 0 45.248z"></path></svg></span></span>');
            });
        }

        /* $('.menu-item').each(function(e, el) {
            if($(el).find('.sub-menu').children().length === 0) {
                const subItem = $(this).find('.sub-icon');
                subItem.css({'display':'none'});
            }
        }); */

        this.bindEvents();
        document.querySelector('.js-search-suggestions-input').addEventListener('keydown', function(event) {
            if (event.key === 'Enter') {
                event.preventDefault();
                document.querySelector('.js-site-header__search-icon').click();
            }
        });

        $('.js-main-nav').on('click', function(e) {
            if($(this).hasClass('open')) {
                console.log(e.target);
                if(!$('.js-primary-menu-wrapper').is(e.target) &&
                $('.js-primary-menu-wrapper').has(e.target).length === 0) {
                    Menu.$domMenuBtn.removeClass(Menu.classOpen);
                    Menu.$domMenuNav.removeClass(Menu.classOpen);
                    Global.$domBody.removeClass(Menu.classOpenMenu);
                    $('.js-main-nav').removeClass('open');
                }
            }
        });

        $('.js-mm-menu-back').on('click', function() {
            $('.sub-menu').removeClass('sub-open');
        });

        $('.js-mm-menu-close').on('click', function() {
            Menu.$domMenuBtn.removeClass(Menu.classOpen);
            Menu.$domMenuNav.removeClass(Menu.classOpen);
            Global.$domBody.removeClass(Menu.classOpenMenu);
            $('.js-main-nav').removeClass('open');
        });

        $('.js-mm-menu-close--sub').on('click', function() {
            Menu.$domMenuBtn.removeClass(Menu.classOpen);
            Menu.$domMenuNav.removeClass(Menu.classOpen);
            Global.$domBody.removeClass(Menu.classOpenMenu);
            $('.js-main-nav').removeClass('open');
        });
    },

    /** @description Bind Events */
    bindEvents: function() {
        function closeNav() {
            Menu.$domMenuBtn.removeClass(Menu.classOpen);
            Menu.$domMenuNav.removeClass(Menu.classOpen);
            Global.$domBody.removeClass(Menu.classOpenMenu);
            /* $('.sub-menu').stop().slideUp().removeClass('sub-open'); */
            $('.sub-menu').removeClass('sub-open');
        }

        this.$domMenuBtn.on('click', function(e) {
            e.preventDefault();
            Menu.$domMenuBtn.toggleClass(Menu.classOpen);
            Menu.$domMenuNav.toggleClass(Menu.classOpen);
            Global.$domBody.toggleClass(Menu.classOpenMenu);
            /* $('.sub-menu').stop().slideUp().removeClass('sub-open'); */
            $('.sub-menu').removeClass('sub-open');
        });

        $('.sub-icon').on('click', function() {
            if (window.innerWidth < 820) {
                const submenu = $(this).prev();
                $('.sub-menu').removeClass('sub-open');

                const isOpen = submenu.hasClass('sub-open');

                console.log('closed');

                /* $('.sub-menu').removeClass('sub-open').stop().slideUp(); */

                if (!isOpen) {
                    /* submenu.addClass('sub-open').stop().slideDown(); */
                    submenu.addClass('sub-open');
                    console.log('open');
                }
            }
        });

        this.$domMenuBtnIcon.on('click', function(e) {
            e.preventDefault();
            $(this).siblings().click();
        });

        /* $('.site-header__search-icon-mobile').on('click touchstart tap', function() {
            $('.js-header-search').addClass('opened');
            setTimeout(() => {
                $('.js-header-search').click();
            }, 0);
            Menu.$searchInput.blur().focus();

            const evt = document.createEvent('HTMLEvents');
            evt.initEvent('click', true, true);
            document.getElementsByClassName('js-search-input-mob')[0].dispatchEvent(evt);
        }); */

        // copy content from mobile search input to standard search input
        // eslint-disable-next-line no-unused-vars
        // $('.js-search-input-mob').on('input change', function(e) {
        //     Menu.$searchInput.val($(this).val());
        // });

        // don't change this or search input on mobile devices will not work
        // Mutation observer detect when search mobile form is loaded on website
        // and at that moment is cloning hidden search input which is needed so search searchanise
        // form can save "q" param in url after search value is submitted
        // couldn't find better way for this
        const observer = new MutationObserver((mutations, observer) => {
            const targetElement = document.querySelector('.site-header__search-icon-mobile');
            if (targetElement) {

                // Find the input element to clone
                const inputElement = document.querySelector('input.search-suggestions-input--alt.js-search-suggestions-input');
                if (inputElement) {
                    // Clone the input element
                    const clonedInput = inputElement.cloneNode(true);

                    // Append the cloned input into the target element
                    targetElement.appendChild(clonedInput);
                } else {
                    console.warn('Input element not found, unable to clone.');
                }

                // Stop observing after the element is found and processed
                observer.disconnect();
            }
        });

        // Start observing changes in the document body
        observer.observe(document.body, {childList: true, subtree: true});


        /* Global.clickOutsideContainer($(document), this.$domMenuNavWrapper, this.$domMenuBtnClose, closeNav); */

        Global.escKey(closeNav);

        Global.clickOutsideContainer($('body'), $('.js-site-header__search-wrapper'), $('.js-site-header__search-icon-x'), closeSearch);

        Global.clickOutsideContainer($('body'), $('.dropdown-acc'), $('.site__preheader-right-list-item-submenu--salesman'), closeDropdown);

        Global.escKey(closeSearch);

        $('.js-site-header__search-icon-x').on('click', function() {
            closeSearch();
        });

        function closeSearch() {
            $('.js-site-header__search-wrapper').removeClass('site-header__search-wrapper--active');
        }

        function closeDropdown() {
            $('.js-dropdown').removeClass('active');
            Menu.$domPreheaderRightListItemSubMenu.removeClass(Menu.classSitePreheaderSubActive);
            Global.$domBody.removeClass('menu-open-overlay');
        }

        this.triggerSearchFormOnSearchIconClick();
    },

    triggerSearchFormOnSearchIconClick: function() {
        document.addEventListener('click', (event) => {
            // Check if the clicked element has the target class
            const searchIcon = event.target.closest('.js-site-header__search-icon');

            if (searchIcon) {
                // Find the closest form ancestor
                const form = searchIcon.closest('form');

                if (form) {
                    // Find the input inside the form
                    const input = form.querySelector('.js-search-suggestions-input');

                    if (input) {
                        console.log('Simulating Enter key press on:', input);

                        // Create and dispatch the Enter key event
                        const enterEvent = new KeyboardEvent('keydown', {
                            bubbles: true,
                            cancelable: true,
                            key: 'Enter',
                            code: 'Enter',
                            keyCode: 13
                        });

                        input.dispatchEvent(enterEvent);
                    } else {
                        console.warn('No input found inside the form.');
                    }
                } else {
                    console.warn('No form found for the clicked search icon.');
                }
            }
        });
    },

    toggleMegaMenuItems: () => {
        $('.js-megamenu-dropdown__box').on('mouseover', function() {
            const categoryTitle = $(this).attr('data-category-title');

            $('.js-megamenu-dropdown__box').removeClass('show-the-box');
            $('.js-megamenu-dropdown__box-text-wrapper').removeClass('show-the-box');

            const selectorCategoryBox = $(`.js-megamenu-dropdown__box-text-wrapper[data-category-box="${categoryTitle}"]`);
            selectorCategoryBox.addClass('show-the-box');

            $(this).addClass('show-the-box');
        });
    },

    appendMegaMenu: () => {
        $('.js-main-nav').append('<ul class="primary-menu"></ul><div class="primary-menu__bottom-box"></div>');

        $('.megamenu-dropdown__box').each(function(e, el) {
            const link = $(el).find('.megamenu-dropdown__box-title');
            const linkData = link.parent().attr('data-category-title');

            $('.primary-menu').append(`
				<li class='menu-item menu-item-has-children mm-menu-item mm-menu-item-${e}' data-category-title='${linkData}'><a href='${link[0].href}'>${link[0].text}</a>
					<ul class="sub-menu">
                        <span class="mm-menu-back js-mm-menu-back">
                            <img src="../../wp-content/themes/fws-kadra/src/assets/images/nav-back.png" alt="Back" />
                            Back
                        </span>
                        <span class="mm-menu-close mm-menu-close--sub js-mm-menu-close--sub"></span>
                        <span class="mm-menu-categorie">${linkData}</span>
                    </ul>
				</li>
			`);

            const elementTitleData = $(el).attr('data-category-title');

            const listItem = $(`.js-megamenu-dropdown__box-text-wrapper[data-category-box=${elementTitleData}]`).find('ul li');
            $(`.mm-menu-item-${e}[data-category-title="${elementTitleData}"] .sub-menu`).append(listItem);
        });
    },

    showHideSubMenu: function() {
        // eslint-disable-next-line no-unused-vars
        Menu.$domPreheaderRightListItem.on('click', function(e) {
            if (Menu.$domPreheaderRightListItemSubMenu.hasClass(Menu.classSitePreheaderSubActive)) {
                Menu.$domPreheaderRightListItemSubMenu.removeClass(Menu.classSitePreheaderSubActive);
                Menu.$domPreheaderRightListItemSubMenu.addClass(Menu.classSitePreheaderSubDeActive);
                $(this).children().css('color', '#000');
                Menu.$domSalesmanDropdown.removeClass('active');
                Global.$domBody.removeClass('menu-open-overlay');
            } else {
                Menu.$domPreheaderRightListItemSubMenu.removeClass(Menu.classSitePreheaderSubDeActive);
                Menu.$domPreheaderRightListItemSubMenu.addClass(Menu.classSitePreheaderSubActive);
                $(this).children().css('color', '#f0c201');
                Menu.$domSalesmanDropdown.addClass('active');
                Global.$domBody.addClass('menu-open-overlay');
            }
        });
    },

    showHideDropdown: function() {
        // eslint-disable-next-line no-unused-vars
        Menu.$domDropdownItem.on('click', function(e) {
            Menu.$domPreheaderRightListItemSubMenu.toggleClass(Menu.classSitePreheaderSubActive);
            Menu.$domSalesmanDropdown.toggleClass('active');
            Global.$domBody.toggleClass('menu-open-overlay');
        });
    },

    mergeTopMenu: () => {
        if ($('.mm-holder__nav').length) {
            const productsLink = $('.mm-holder__nav').attr('href');
            $('.primary-menu').wrap('<div class="primary-menu-wrapper js-primary-menu-wrapper"></div>');

            $('.js-primary-menu-wrapper').append(`
                <div class="primary-menu__bottom-box">
                    <p>Need Support? Contact Us!</p>
                    <a href="tel:7322765992">732-276-5992</a>
                    <a href="mailto:sales@kadrakitchenware.com">sales@kadrakitchenware.com</a>
                </div>
                `);

            $('.primary-menu').prepend(`
                <span class="mm-menu-close js-mm-menu-close"></span>
				<li class="menu-item mm-menu-item"><a href="${productsLink}">Browse All</a></li>
				<li class="menu-item mm-menu-item mm-menu-item--new-arrivals"><a href="/product-category/new-arrivals"><span>new</span>Arrivals</a></li>
			`);
        }
        $('.site__preheader-right-list-item').each((i, el) => {
            const title = $(el).find('> .site__preheader-right-list-item-title');
            const dataAttr = $(el).data('hide-on-mobile');
            const subList = $(el).find('.site__preheader-right-list-item-submenu').length;
            const hasChild = subList ? 'menu-item-has-children' : '';

            // hide link on mobile
            if (dataAttr === 'hide-on-mobile') {
                return;
            }
            if (title.length) {
                if (title.text() === 'Catalog') {
                    $('.primary-menu').append(`
					<li class="menu-item mm-menu-item ${hasChild} menu-item-${i}"><a href="${title.attr('href')}" rel='noopener' target='_blank'>${title.text()}</a></li>
				`);
                } else {
                    $('.primary-menu').append(`
						<li class="menu-item mm-menu-item ${hasChild} menu-item-${i}"><a href="${title.attr('href')}">${title.text()}</a></li>
					`);
                }

            }

            if (subList) {
                $(`.menu-item-${i}`).append(`<ul class="sub-menu sub-menu-${i}"></ul>`);

                $(el).find('.site__preheader-right-list-item-submenu-item').each((index, subEl) => {
                    const subTitle = $(subEl).find('.site__preheader-right-list-item-submenu-item-title');
                    const subSubList = $(subEl).find('.site-preheader-right-list-item-submenu-item-content').length;
                    const subTitlelink = subTitle.attr('href') ? subTitle.attr('href') : 'javascript:;';

                    $(`.sub-menu-${i}`).append(`
						<li class="mm-sub-menu-item mm-sub-menu-item-${index}">
							<a href="${subTitlelink}" class="mm-sub-menu-item-link">${subTitle.text()}</a>
						</li>
					`);

                    if (subSubList) {
                        $(`.mm-sub-menu-item-${index}`).append(`<ul class="mm-sub-menu-${index}"></ul>`);

                        $('.site-preheader-right-list-item-submenu-item-content li').each((ind, subSubEl) => {
                            $(`.mm-sub-menu-${index}`).append(`
								<li class="mm-sub-menu-item">${$(subSubEl).html()}</li>
							`);
                        });
                    }
                });
            }
        });
    }
};

export default Menu;
